import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import './../styles/default.css';
import './../styles/default/home.css';
import * as globals from './../components/GlobalScripts.js';
import NavbarTop from './default/Navbartop';
import Banner from './default/Banner';
import Testimonials from './default/Testimonials';
import Preguntas from './default/Preguntas';
import Contacto from './default/Contacto';
import Footer from './default/Footer';

const Home = () => {
    let path_api = localStorage.getItem('path_api');
    const location = useLocation();
    const [user, setUser] = useState([]);
    const [categoriasOptions, setCategoriasOptions] = useState([]);
    const navigate = useNavigate();
    const cardRefs = useRef({});
    const videoRefs = useRef({});

    const categories = [
        {
            key: 'Pintura',
            title: 'Pintura',
            desc: 'Interiores, exteriores y detalles.',
            poster: '/imagenes/home/pintura.webp',
            video: '/videos/home/pintura.mp4',
            to: 'servicios/Pintura',
        },
        {
            key: 'Fontanero',
            title: 'Fontanería',
            desc: 'Reparaciones, fugas e instalaciones.',
            poster: '/imagenes/home/fontaneria.webp',
            video: '/videos/home/fontaneria.mp4',
            to: 'servicios/Fontanero',
        },
        {
            key: 'Electricista',
            title: 'Electricidad',
            desc: 'Luces, enchufes y tableros',
            poster: '/imagenes/home/electricidad.webp',
            video: '/videos/home/electricidad.mp4',
            to: 'servicios/Electricista',
        },
    ];

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const key = entry.target.dataset.key;
                        const vidEl = videoRefs.current[key];
                        const cat = categories.find(c => c.key === key);
                        if (vidEl && cat && !vidEl.src) {
                            vidEl.src = cat.video;
                            vidEl.load();
                        }
                        obs.unobserve(entry.target);
                    }
                });
            },
            { rootMargin: "200px" }
        );
        categories.forEach(cat => {
            const cardEl = cardRefs.current[cat.key];
            if (cardEl) observer.observe(cardEl);
        });
        return () => observer.disconnect();
    }, []);

    useEffect(() => {
        const user_cache = localStorage.getItem('user');
        if (user_cache) {
            setUser(JSON.parse(user_cache));
        }

        get_categorias();
    }, []);

    const get_categorias = () => {
        axios.post(`${path_api}/default/get_categorias.php`, {
            rute: globals.getRuteBackend()
        }).then(response => {
            if (response.data.mensaje === 'success') {
                setCategoriasOptions(response.data.categorias);
            } else {
                globals.createAlert({ type: "error", msg_title: "Error", msg: response.data.mensaje || "No se cargaron las categorias", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
            }
        }).catch(error => {
            globals.createAlert({ type: "error", msg_title: "Error", msg: "Error al conectar con el servidor", effect: "opacidad 2s, desplazamiento 2s", time_life: 4000 });
        });
    };

    return (
        <div className="app-default app-container">
            <NavbarTop />
            <div className="main-content page-home">
                <div className="page-container">
                    <Banner src="/videos/home/banner-1.mp4?v=5" type="video" overlay="gradient" poster="/imagenes/home/banner-poster.webp?v=2" eagerLoad={true}>
                        <h1 className="text-white">Servicios confiables para tu hogar</h1>
                        <h3 className="text-white">Conectamos personas con profesionales honestos y verificados</h3>
                    </Banner>
                    <div id="servicios" className='container-section section content-center flex-column gap-20'>
                        <p className="title center">Nuestros servicios</p>
                        <h2 className="center">Resuelve lo que necesitas, sin vueltas</h2>
                        <h4 className="center text-p">Contamos con profesionales verificados para ayudarte con lo que necesitás en tu hogar, desde arreglos simples hasta trabajos especializados.</h4>
                        <div className="flex-row gap-40 full-width margin-top">
                            {categories.map(cat => (
                                <div
                                    key={cat.key}
                                    ref={el => (cardRefs.current[cat.key] = el)}
                                    data-key={cat.key}
                                    className="card-category"
                                >
                                    <video
                                        ref={el => (videoRefs.current[cat.key] = el)}
                                        className="card-bg-video"
                                        poster={cat.poster}
                                        muted
                                        autoPlay
                                        loop
                                        playsInline
                                        preload="metadata"
                                    >
                                        <source type="video/mp4" />
                                    </video>
                                    <div className="overlay-container"></div>
                                    <span className="category"><p>{cat.title}</p></span>
                                    <h1 className="text-white">{cat.title}</h1>
                                    <h5 className="text-p margin-top-15 text-white">{cat.desc}</h5>
                                    <Link to={cat.to} className="button-primary no-hover">
                                        Solicitar servicio
                                        <svg viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9.66699 5.75H18.667C18.7332 5.75004 18.7969 5.77639 18.8438 5.82324C18.8906 5.87012 18.917 5.93373 18.917 6V15C18.917 15.0663 18.8906 15.1299 18.8438 15.1768C18.7969 15.2236 18.7332 15.25 18.667 15.25C18.6007 15.25 18.5371 15.2236 18.4902 15.1768C18.4434 15.1299 18.417 15.0663 18.417 15V6.60254L17.5635 7.45605L6.85645 18.1641C6.80905 18.2082 6.74543 18.2326 6.68066 18.2314C6.6161 18.2302 6.55447 18.2038 6.50879 18.1582C6.46299 18.1124 6.43669 18.0501 6.43555 17.9854C6.43476 17.9367 6.44818 17.8893 6.47363 17.8486L6.50293 17.8105L18.0635 6.25H9.66699C9.60072 6.25 9.53711 6.22359 9.49023 6.17676C9.44335 6.12987 9.41699 6.0663 9.41699 6C9.41699 5.9337 9.44335 5.87013 9.49023 5.82324C9.53711 5.77641 9.60072 5.75 9.66699 5.75Z" fill="black" stroke="white" />
                                        </svg>
                                    </Link>
                                </div>
                            ))}
                        </div>
                        <Link to="servicios" className="button-primary white margin-top">Explora todos los servicios disponibles</Link>
                    </div>

                    <div id="nosotros" className='container-section section flex-row gap-40'>
                        <div className="flex-column gap-20 full-width">
                            <h2>Don honesto</h2>
                            <h5>Somos una plataforma digital que conecta a personas con profesionales confiables para servicios esenciales del hogar. Nuestro objetivo es ofrecer una alternativa segura, clara y fácil de usar para quienes buscan soluciones rápidas, confiables y con respaldo</h5>
                            <div className="tags">
                                <div className="tag">Honestidad</div>
                                <div className="tag">Simplicidad</div>
                                <div className="tag">Seguridad</div>
                                <div className="tag">Comunidad</div>
                            </div>
                        </div>
                        <div className="collage">
                            <img src="/imagenes/home/donhonesto-1.webp?v=2" alt="Pintor realizando un trabajo" className="item item1" loading="lazy" />
                            <img src="/imagenes/home/donhonesto-2.webp?v=2" alt="Electricista realizando un trabajo" className="item item2" loading="lazy" />
                            <img src="/imagenes/home/donhonesto-3.webp?v=2" alt="Albañil realizando un trabajo" className="item item3" loading="lazy" />
                            <img src="/imagenes/home/donhonesto-4.webp?v=2" alt="Tapicero realizando un trabajo" className="item item4" loading="lazy" />
                        </div>
                    </div>

                    <div id="ventajas" className='container-section section content-center flex-column gap-40'>
                        <div className="overlay-container-full-width">
                            <div className="overlay-effect-primary left"></div>
                            <div className="overlay-effect-secundary right"></div>
                        </div>
                        <h2 className="center">¿Por qué elegirnos?</h2>
                        <div className="container-card-advantages">
                            <div className="card-advantages">
                                <img src="/imagenes/home/advantages-1.webp" alt="Técnicos verificados" loading="lazy" />
                                <h3 className="center">Técnicos verificados</h3>
                            </div>
                            <div className="card-advantages">
                                <img src="/imagenes/home/advantages-2.webp" alt="Servicios garantizados" loading="lazy" />
                                <h3 className="center">Servicios garantizados</h3>
                            </div>
                            <div className="card-advantages">
                                <img src="/imagenes/home/advantages-3.webp" alt="Facturación disponible" loading="lazy" />
                                <h3 className="center">Facturación disponible</h3>
                            </div>
                            <div className="card-advantages">
                                <img src="/imagenes/home/advantages-4.webp" alt="Soporte y seguimiento" loading="lazy" />
                                <h3 className="center">Soporte y seguimiento</h3>
                            </div>
                        </div>
                    </div>

                    <div id="como-funciona" className='container-section section flex-row gap-40'>
                        <div className="flex-column gap-20 full-width">
                            <p className="title">¿Cómo funciona?</p>
                            <h2>Así de fácil es usar Don Honesto</h2>
                            <h5>Solicita un servicio en minutos, sin complicaciones. Así funciona nuestra plataforma</h5>
                        </div>
                        <div className="how-work">
                            <div className="card-how-work">
                                <img src="/imagenes/home/how-work-1.webp" alt="Seleccioná el servicio que necesitás" loading="lazy" />
                                <div className="flex-column gap-20">
                                    <h4>Selecciona el servicio que necesitás</h4>
                                    <p>Elige entre pintura, fontanería, electricidad u otros servicios</p>
                                </div>
                            </div>
                            <div className="divider-how-work primary"></div>
                            <div className="card-how-work">
                                <img src="/imagenes/home/how-work-2.webp" alt="Completá el formulario" loading="lazy" />
                                <div className="flex-column gap-20">
                                    <h4>Completa el formulario</h4>
                                    <p>Cuentanos qué necesitás, dónde estás y cómo contactarte</p>
                                </div>
                            </div>
                            <div className="divider-how-work secundary"></div>
                            <div className="card-how-work">
                                <img src="/imagenes/home/how-work-3.webp" alt="Recibe una confirmación" loading="lazy" />
                                <div className="flex-column gap-20">
                                    <h4>Recibe una confirmación</h4>
                                    <p>Nuestro equipo se pondrá en contacto para coordinar el servicio</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <Banner id="profesionales" src="/videos/home/banner-2.mp4?v=2" type="video" overlay="gradient">
                        <div className='container-section section'>
                            <div className="professionals-section">
                                <h2 className="text-white center">¿Eres profesional en alguna de estas áreas?</h2>
                                <h5 className="text-white center text-p">Súmate a nuestra red y encontrá más trabajos, con respaldo y sin pagar por prospectos</h5>

                                <div className="tags">
                                    {categoriasOptions.map((categoria, index) => (
                                        <div key={index} className="tag">
                                            {categoria}
                                        </div>
                                    ))}
                                </div>

                                <div className="flex-row center gap-20">
                                    <Link to="quiero-trabajar" className="button-primary">Únete como profesional</Link>
                                    <Link to="oferta-profesionales" className="button-primary transparent-white">Mira lo que te ofrecemos</Link>
                                </div>
                            </div>
                        </div>
                    </Banner>

                    <Testimonials />

                    <Preguntas />

                    <Contacto />
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default Home;
